// extracted by mini-css-extract-plugin
module.exports = {"contact-card":"ContactCard_contact-card__3VIfu","contact-card__info":"ContactCard_contact-card__info__2l47U","contact-card__info-icon":"ContactCard_contact-card__info-icon__2PA8d"};